const textBox = { display: 'flex', justifyContent: 'space-between', alignItems: 'center' };

const titleStyle = {
  fontSize: '14px',
  fontWeight: 700,
};

const conditionsBox = {
  display: 'flex',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  rowGap: '8px',
  padding: '9px 0',
};

const delayTitle = {
  fontSize: '14px',
  fontWeight: 400,
};

export { textBox, titleStyle, conditionsBox, delayTitle };
